import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { Button, Select } from 'element-ui';
import userManager from "@/views/About.vue";

import VueRouter from 'vue-router'

Vue.component(Button.name, Button);
Vue.component(Select.name, Select);

Vue.use(ElementUI);
Vue.use(VueRouter)
Vue.config.productionTip = false

const routes = [
  {
    path: "/about",
    name: "About",
    userManager
  }
]
const router = new VueRouter({
  routes
})
new Vue({
  router: router,
  render: h => h(App),
}).$mount('#app')
